import { useResizeObserver } from '../useResizeObserver';

export const Chart = ({ children, emptyMessage = 'No data' }) => {
  const { ref, width, height } = useResizeObserver();
  return (
    <div ref={ref} className="absolute inset-0">
      {width > 0 && height > 0 ? (
        typeof children === 'function' ? (
          children({ width, height })
        ) : (
          children
        )
      ) : null}
      {width === 0 && (
        <div className="absolute inset-0 grid place-items-center text-xs text-f1-muted">
          {emptyMessage}
        </div>
      )}
    </div>
  );
};
